<template>
  <div>
    <!-- 业务决策 -->
    <el-dialog :title="$t('message.businessDecisions')" :close-on-click-modal="false"
      :visible.sync="$parent.businessDecisionsDialogVisible" width="1800px">
      <div class="table">
        <ol>
          <!-- 选择 -->
          <li class="flex05">
            <el-checkbox v-model="checked" @change="allChecked">
              <!-- {{ $t("message.allChecked") }} -->
            </el-checkbox>
          </li>
          <!-- 选择 -->
          <li class="flex05">NO</li>
          <!--  店铺信息-->
          <li class="flex15">
            {{ $t("message.storeInformation") }}
          </li>
          <!--照片-->
          <li>{{ $t("message.pic") }}</li>
          <!-- 商品属性 -->
          <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
          <!--业务报价  -->
          <li>{{ $t("message.businessOffer") }}</li>
          <!-- 财务付款后数量 -->
          <li>{{ $t("message.afterFinancialPaymentNum") }}</li>
          <!-- 财务付款后金额 -->
          <li>{{ $t("message.afterFinancialPaymentKin") }}</li>
          <!--商品状态  -->
          <li>{{ $t("message.itemStatus") }}</li>
          <!-- 问题类别 -->
          <li class="flex2">
            {{ $t("message.typeOfProblem") }}
          </li>
          <!-- 问题产品数 -->
          <li>{{ $t("message.problemNunber") }}</li>
          <!-- 修改后数据 -->
          <li class="flex2">
            {{ $t("message.modifiedData") }}
          </li>
          <!-- 问题描述  -->
          <li class="flex2">{{ $t("message.problemDescription") }}</li>
          <!-- 客户回复  -->
          <li class="flex2">{{ $t("message.userReply") }}</li>
          <!-- 业务翻译  -->
          <li class="flex2">{{ $t("message.businessTranslation") }}</li>
          <!-- 业务决策  -->
          <li class="flex2">
            {{ $t("message.businessDecisions") }}
          </li>
          <!-- 手续费  -->
          <li class="flex2">{{ $t("message.poundage") }}</li>
          <!-- 附加服务费  -->
          <li class="flex25">
            {{ $t("message.additionalServiceCharge") }}
          </li>
        </ol>
        <!-- 订单详情 -->
        <div class="detail" v-for="(item, index) in disposeList" :key="index">
          <!-- 交易号 -->
          <div class="head">
            {{ $t("message.transactionNumber") }}:
            <a :href="'https://trade.1688.com/order/new_step_order_detail.htm?orderId=' + item.purchase_no"
              v-if="item.purchase_no" target="_blank">
              {{ item.purchase_no }}</a>
            <span v-else> ———— </span>
            <span style="margin-left: 50px;"> 订单号: <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn"
                target="_blank">{{ item.order_sn }}</router-link></span>

          </div>
          <ul v-for="(items, indexs) in item.list" :key="indexs">
            <li class="flex05">
              <div>
                <el-checkbox v-model="items.checked" @change="choice"></el-checkbox>
              </div>
            </li>
            <li class="flex05">{{ items.sorting }}</li>
            <!-- 选择 -->
            <!--  店铺信息-->
            <li class="flex15">
              <div class="template">
                <p>{{ items.shop_name }}</p>
                <p>{{ items.from_platform }}</p>
                <p>{{ items.shop_id }}</p>
              </div>
            </li>
            <!--照片-->
            <li>
              <div class="img">
                <el-popover placement="right" width="300" trigger="hover">
                  <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                  <a :href="`https://detail.1688.com/offer/${items.goods_id}.html`" target="_blank" slot="reference">
                    <img :src="items.pic" alt="" />
                  </a>
                </el-popover>
                <!-- 替换链接 -->
                <el-button type="text" @click="replaceLink(items)"
                  :style="{ color: items.replace_goods_info == '' ? '' : '#000' }">{{ $t("message.replaceLink")
                  }}</el-button>
              </div>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="template">
                <p v-for="(skuItem, skuIndex) in items.detail_y" :key="skuIndex">
                  <span>{{ skuItem.key }}:</span>
                  <span>{{ skuItem.value }}</span>
                </p>
              </div>
            </li>
            <!--业务报价  -->
            <li>
              <div class="template">
                <!-- 单价 -->
                <!-- <p>
                  {{ $t("message.unitPrice") }}:{{ items.dicker_price }}
                </p> -->
                <!-- 价格 -->
                <p>{{ $t("message.price") }}:{{ items.offer_price_bak }}</p>
                <!-- 数量 -->
                <p>{{ $t("message.number") }}:{{ items.offer_num_bak }}</p>
                <!-- 运费-->
                <p>{{ $t("message.freight") }}:{{ items.offer_freight_bak }}</p>
              </div>
            </li>
            <!-- 财务付款后数量 -->
            <li>
              <div class="template">
                <!-- 可入库 -->
                <p>
                  {{ $t("message.canBePutIntoStorage") }}:{{ items.possible_num ? items.possible_num : "——" }}
                </p>
                <!-- 已到货 -->
                <p>
                  {{ $t("message.itHasArrived") }}:{{ items.storage_num ? items.storage_num : "——" }}
                </p>
                <!-- 已出货 -->
                <p>
                  {{ $t("message.hasBeenShipped") }}:{{ items.p_num ? items.p_num : "——" }}
                </p>
                <!-- 运费 -->
                <p>
                  {{ $t("message.freight") }}:{{ items.freight ? items.freight : "——" }}
                </p>
              </div>
            </li>
            <!-- 财务付款后金额 -->
            <li>
              <div class="template">
                <!-- 价格 -->
                <p>{{ $t("message.price") }}:{{ items.ccomfirm_price }}</p>
                <!-- 运费-->
                <p>{{ $t("message.freight") }}:{{ items.ccomfirm_freight }}</p>
              </div>
            </li>
            <!--商品状态  -->
            <li>{{ items.product_status_name }}</li>
            <!-- 问题类别 -->
            <li class="flex2">
              <div class="template">

                <!-- 是否补买 -->
                <p style="text-align: center;" v-if="[3, 4, 5].indexOf(items.type) != -1">
                  <el-checkbox v-model="items.is_purchase_add">
                    {{ $t("message.isReplace") }}
                  </el-checkbox>
                </p>
                <p style="margin: 7px 0; ">
                  <el-select v-model="items.type" placeholder="请选择" size="small" filterable allow-create
                    default-first-option @change="setType(index, indexs, items)">
                    <el-option v-for="item in problemTypes" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </p>
                <!-- 赔款单号 -->
                <p v-if="[3, 4, 5].indexOf(items.type) != -1">
                  <el-input v-model="items.purchase_add_reparation_sn" :placeholder="$t('message.claimNumber')"
                    size="small">
                  </el-input>
                </p>
              </div>
            </li>
            <!-- 问题产品数 -->
            <li>
              {{ items.num }}
            </li>
            <!-- 修改后数据 -->
            <li class="flex2">
              <div class="template">
                <!-- 修改后数量 -->
                <p :class="{ difference: items.pre_num != items.possible_num }">{{ $t("message.editNumber")
                }}:{{ items.pre_num }}</p>
                <!-- 修改后单价 -->
                <p :class="{ difference: items.pre_price != items.offer_price_bak }">{{ $t("message.editPrice") }}:
                  {{ items.pre_price }}</p>
                <!-- 修改后运费 -->
                <p :class="{ difference: items.pre_freight != items.offer_freight_bak }">
                  {{ $t("message.editFreight") }}:
                  {{ items.pre_freight }}
                </p>
                <el-popover placement="bottom-start" width="400" trigger="click" v-if="items.option_new">
                  <el-table :data="items.option_new" border size="mini" show-summary>
                    <el-table-column property="name" label="附加服务" align="center"></el-table-column>
                    <el-table-column property="num" label="数量" align="center"></el-table-column>
                    <el-table-column label="单价" align="center">
                      <template slot-scope="scope">
                        {{ scope.row.price }} {{ scope.row.unit }}
                      </template>
                    </el-table-column>
                    <el-table-column label="小计.元" align="center" property="total">
                    </el-table-column>
                  </el-table>
                  <div class="template" slot="reference">
                    <div v-for="(opti, optis) in items.option_new" :key="opti.id">
                      <p>{{ optis + 1 }}, {{ opti.name }} * {{ opti.num }}</p>
                    </div>
                  </div>
                </el-popover>
              </div>
            </li>
            <!-- 具体问题描述 -->
            <li class="flex2">
              {{ items.description }}
            </li>
            <!-- 客户回复  -->
            <li class="flex2">{{ items.client_deal }}</li>
            <!-- 业务翻译 -->
            <li class="flex2">
              <span v-if="items.description_translate">
                {{ items.description_translate }}
              </span>
            </li>
            <!-- 业务决策  -->
            <li class="flex2">
              <el-input v-model="items.content_y" type="textarea" :placeholder="$t('message.businessDecisions')"
                onfocus="this.select()" @input="allText('content_y', items.content_y, items.checked)"></el-input>
            </li>
            <!-- 手续费  -->
            <li class="flex2">
              <div class="template">
                <!-- 已收不退 -->
                <p style="margin-bottom: 10px">
                  <el-radio v-model="items.service_deal_suggest" label="1"
                    @change="hintIrreversible(items)">已收不退</el-radio>
                </p>
                <!-- 多退少补 -->
                <p>
                  <el-radio v-model="items.service_deal_suggest" label="2"
                    @change="hintFillLesse(items)">多退少补</el-radio>
                </p>
              </div>
            </li>
            <!-- 附加服务费  -->
            <li class="flex25">
              <div class="template">
                <!--  按业务修改值计算-->
                <p style="margin-bottom: 10px">
                  <el-radio v-model="items.option_deal_suggest" label="1"
                    @change="hintOption(items.option_new, true, items)">按业务修改值计算</el-radio>
                </p>
                <!-- 系统自动计算 -->
                <p>
                  <el-radio v-model="items.option_deal_suggest" label="2"
                    @change="hintOption(items.option_new, false, items)">系统自动计算</el-radio>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="footer">
          <p style="color: #b4272d" class="fl">
            注意： 手续费选择【已收不退】后，商品数量减少时：将不会自动退还客户
            由于商品数量减少导致的手续费差额！
          </p>
          <!--业务决策  -->
          <el-button type="primary" @click="problemY_deal" class="fr">
            {{ $t("message.businessDecisions") }}
          </el-button>
          <el-button type="primary" @click="previewOfDepositAndWithdrawal" class="fr"
            style="margin-right: 20px;">出入金预览</el-button>
          <div class="fr radio">
            <p>
              是否需要采购处理：<span>
                <el-radio v-model="jump_g" label="0">需要采购处理</el-radio></span>
              <span>
                <!--  @change="skipPurchase" -->
                <el-radio v-model="jump_g" label="1" @change="skipPurchase">跳过采购</el-radio></span>
            </p>
            <p>
              是否需要配货确认：<span>
                <el-radio v-model="jump_p" label="0">需要配货确认</el-radio></span>
              <span>
                <el-radio v-model="jump_p" label="1" @change="skipDistribution">不需要配货确认</el-radio></span>
            </p>
          </div>
        </div>
      </span>
    </el-dialog>
    <!-- 查看大图 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="picDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <!-- 出入金明细 -->
    <previewOfDepositAndWithdrawal :tableData="tableData" ref="previewOfDepositAndWithdrawal" />
    <!-- 替换链接编辑 -->
    <replaceLinkEdit ref="replaceLinkEdit" @refresh="refresh" />
  </div>
</template>
<script>
import previewOfDepositAndWithdrawal from './previewOfDepositAndWithdrawal'
import replaceLinkEdit from './replaceLinkEdit'
export default {
  props: {
    disposeList: { type: Array },
  },
  components: {
    previewOfDepositAndWithdrawal,
    replaceLinkEdit,
  },
  data() {
    return {
      jump_g: "0",
      jump_p: "0",
      picDialogVisible: false,
      dialogImageUrl: "",
      checkedList: [],
      checked: false,
      tableData: [],//出入金明细
    };
  },
  created() {
    // 弹窗首次打开时，按价格、运费、option 和数量变化初始化手续费处理方式。
    this.setDefaultServiceDealSuggest();
  },

  computed: {
    problemTypes() {
      return this.$store.state.problemTypes;
    },
  },
  methods: {

    // 比较数值字段时兼容接口返回的数字和数字字符串。
    valueChanged(current, original) {
      if (current == null && original == null) return false
      const currentNumber = Number(current)
      const originalNumber = Number(original)
      if (!Number.isNaN(currentNumber) && !Number.isNaN(originalNumber)) {
        return currentNumber !== originalNumber
      }
      return String(current) !== String(original)
    },
    // 单价、运费、option 发生变化，或修改后数量增加时，默认采用多退少补。
    shouldRefundDifference(items) {
      const optionChanged = items.option_new != null
      const quantityIncreased = Number(items.pre_num) > Number(items.offer_num_bak)
      return this.valueChanged(items.pre_price, items.offer_price_bak)
        || this.valueChanged(items.pre_freight, items.offer_freight_bak)
        || optionChanged
        || quantityIncreased
    },
    // 业务决策弹窗每次创建时统一设置手续费默认选项，其他情况默认已收不退。
    setDefaultServiceDealSuggest() {
      this.disposeList.forEach(item => {
        item.list.forEach(items => {
          if(!items.service_deal_suggest){
            items.service_deal_suggest = this.shouldRefundDifference(items) ? '2' : '1'
          }else{
            items.service_deal_suggest = items.service_deal_suggest + '';
          }
          
        })
      })
    },

    //问题产品-业务决策
    problemY_deal() {
      let datas = {
        data: [],
        jump_g: this.jump_g,
        jump_p: this.jump_p,
      };
      let str = '' // 数量 提示
      let optionStr = '' // 附加服务 提示
      this.disposeList.forEach((item) => {
        let strItem = {
          min: [],
          max: [],
        }
        item.list.forEach((items) => {
          datas.data.push({
            problem_goods_id: items.problem_goods_id,
            content: items.content_y,
            service_deal_suggest: items.service_deal_suggest,
            option_deal_suggest: items.option_deal_suggest,
            type: items.type,
            is_purchase_add: [3, 4, 5].indexOf(items.type) != -1 ? items.is_purchase_add ? 1 : 0 : '',
            purchase_add_reparation_sn: [3, 4, 5].indexOf(items.type) != -1 ? items.purchase_add_reparation_sn : '',
          });
          if (items.offer_num_bak - items.pre_num > 0) {
            strItem.min.push({
              num: items.offer_num_bak - items.pre_num,
              sorting: items.sorting
            })
          } else if (items.offer_num_bak - items.pre_num < 0) {
            strItem.max.push({
              num: items.pre_num - items.offer_num_bak,
              sorting: items.sorting
            })
          }
          // 跳过采购
          if (this.jump_g == 1) {
            // 详细检品(单价) 收费检查
            let option = items.option_new != null ? items.option_new : items.option

            if (option) {
              let optionData = option.find(opti => opti.name == '详细检品(单价)')
              let price = items.pre_price != items.offer_price_bak ? items.pre_price : items.offer_price_bak
              if (optionData != undefined) {
                if (price <= 30) {
                  if ((price > 15 && optionData.price != 2) || (price <= 15 && optionData.price != 1.5)) {
                    optionStr += `<span  style="color:red;">${item.order_sn}-${items.sorting}番</span>，详细检品收费与收费标准不一致，请确认后再决策。<br/>`
                  }
                }
              }
            }
          }
        });
        if (strItem.min != false || strItem.max != false) {
          str += `<div>${item.order_sn}<div>`
          strItem.min.forEach(items => {
            str += `${items.sorting}番 数量有<span  style="color:red;"">减少${items.num}</span>。<br/>`
          })
          strItem.max.forEach(items => {
            str += `${items.sorting}番 ，数量<span  style="color: #67C23A;"">增加${items.num}</span>。<br/>`
          })
        }
      });
      if (!datas.data.every((item) => item.content_y != ""))
        return this.$message.error("有订单未填写业务决策内容");
      if (str) {
        this.$alert(`<div style="font-size:20;px;max-height: 500px;
  overflow-y: auto;">
       ${str}
        </div>`, '提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          callback: action => {
            if (action == 'confirm') {
              this.y_deal(datas, optionStr)
            }
          }
        });
      } else {
        this.y_deal(datas, optionStr)
      }
      // console.log(datas);
    },
    // 业务决策
    y_deal(datas, optionStr) {
      if (optionStr) {
        this.$alert(`<div style="font-size:20;px;max-height: 500px;
  overflow-y: auto;">
       ${optionStr}
        </div>`, '提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          callback: action => {
            if (action == 'confirm') {
              this.$api.problemApi.y_deal(datas).then((res) => {
                if (res.code != 0) return this.$message.error(res.msg);
                this.$message.success(res.msg);
                this.$parent.businessDecisionsDialogVisible = false;
                this.$parent.problemList();
              });
            }
          }
        });
      } else {
        this.$api.problemApi.y_deal(datas).then((res) => {
          if (res.code != 0) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          this.$parent.businessDecisionsDialogVisible = false;
          this.$parent.problemList();
        });
      }

    },
    //出入金预览
    previewOfDepositAndWithdrawal() {
      let datas = {
        data: [],
        jump_g: 1,
        jump_p: this.jump_p,
        preview_bill: 1
      };
      let str = ''
      this.disposeList.forEach((item) => {
        let strItem = {
          min: [],
          max: [],
        }
        item.list.forEach((items) => {
          datas.data.push({
            problem_goods_id: items.problem_goods_id,
            content: items.content_y,
            service_deal_suggest: items.service_deal_suggest,
            option_deal_suggest: items.option_deal_suggest,
            type: items.type_name,
          });

          if (items.offer_num_bak - items.pre_num > 0) {
            strItem.min.push({
              num: items.offer_num_bak - items.pre_num,
              sorting: items.sorting
            })
          } else if (items.offer_num_bak - items.pre_num < 0) {
            strItem.max.push({
              num: items.pre_num - items.offer_num_bak,
              sorting: items.sorting
            })
          }

        });

        if (strItem.min != false || strItem.max != false) {
          str += `<div>${item.order_sn}<div>`
          strItem.min.forEach(items => {
            str += `${items.sorting}番 数量有<span  style="color:red;"">减少${items.num}</span>。<br/>`
          })
          strItem.max.forEach(items => {
            str += `${items.sorting}番 ，数量<span  style="color: #67C23A;"">增加${items.num}</span>。<br/>`
          })

        }

      });
      this.$api.problemApi.y_deal(datas).then((res) => {
        this.tableData = res.data
        this.tableData.forEach(item => {
          item.adjust_detail = JSON.parse(item.adjust_detail)
        })
        this.$forceUpdate()
        this.$refs.previewOfDepositAndWithdrawal.dialogVisible = true
      });

    },
    //手续费选择【已收不退】后，
    hintIrreversible(data) {
      this.$alert(
        "手续费选择【已收不退】后，商品数量减少时：将不会自动退还客户由于商品数量减少导致的手续费差额！商品数量增加时：还是会自动和客户收取数量增加的手续费差额！",
        "已收不退",
        {
          confirmButtonText: "确定",

          callback: (action) => {
            // this.$message({
            //   type: "info",
            //   message: `action: ${action}`,
            // });
          },
        }
      );
      if (data.checked) {
        this.disposeList.forEach(item => {
          item.list.forEach(items => {
            if (items.checked) {
              items.service_deal_suggest = data.service_deal_suggest
            }
          })
        })
      }
    },
    //手续费选择【多退少补】后，
    hintFillLesse(data) {
      this.$alert(
        "手续费选择【多退少补】后,商品数量减少时：将自动退还客户由于商品数量减少导致的手续费差额！",
        "多退少补",
        {
          confirmButtonText: "确定",
          callback: (action) => { },
        }
      );
      if (data.checked) {
        this.disposeList.forEach(item => {
          item.list.forEach(items => {
            if (items.checked) {
              items.service_deal_suggest = data.service_deal_suggest
            }
          })
        })
      }
    },
    //按业务修改值计算
    hintOption(option, show, data) {
      console.log(option, show);
      if (option && show) {
        let flag = option.some((item) => item.id == 9 || item.id == 8);
        if (flag) {
          this.$alert(
            "当前选中各番存在【摄影】【配套】请确认是否已经修改好相应的 附加服务 数量及价格！！",
            "提示",
            {
              confirmButtonText: "确定",
            }
          );
        }
      }
      if (data.checked) {
        // 批量
        this.disposeList.forEach(item => {
          item.list.forEach(items => {
            if (items.checked) {
              items.option_deal_suggest = data.option_deal_suggest
            }
          })
        })
      }

    },
    //修改后的数量为0的时候
    no0(num) {
      if (num == 0) {
        this.$alert("修改后数量为0,请确认运费是否需要修改！", "提示", {
          confirmButtonText: "确定",
          callback: (action) => { },
        });
      }
    },
    // 查看大图
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.picDialogVisible = true;
    },
    //全选
    allChecked() {
      this.disposeList.forEach(item => {
        item.list.forEach(items => {
          items.checked = this.checked
        })
      })
      this.$forceUpdate()
    },
    //批量修改
    allText(tpye, text, checked) {
      if (checked) {
        this.disposeList.forEach(item => {
          item.list.forEach(items => {
            if (items.checked) {
              items[tpye] = text
            }
          })
        })
      }
      this.$forceUpdate()
    },
    //单选
    choice() {
      let list = []
      this.disposeList.forEach(item => {
        item.list.forEach(items => {
          if (items.checked) {
            list.push(item)
          }

        })
      })
      this.checked = list.every(item => item.checked)
      this.$forceUpdate()
    },
    //跳过采购提示
    skipPurchase() {
      for (let i = 0; i < this.disposeList.length; i++) {
        let flag = this.disposeList[i].created_admin_work_type.some(item => item == 2)
        if (flag) {
          return this.$alert(
            this.disposeList[i].purchase_no + "这交易号的问题产品是采购提的，确认要跳过采购吗",
            "提示",
            {
              confirmButtonText: "确定",
              center: true,
            }
          );
        }
      }

    },
    //配货提示
    skipDistribution() {
      for (let i = 0; i < this.disposeList.length; i++) {
        let flag = this.disposeList[i].created_admin_work_type.some(item => item == 5)
        if (flag) {
          return this.$alert(
            this.disposeList[i].purchase_no + "这交易号的问题产品配货提的，确认不需要配货确认吗",
            "提示",
            {
              confirmButtonText: "确定",
              center: true,
            }
          );
        }
      }
    },
    // 设置手续费
    setType(index, indexs, items) {
      // 切换问题类型后仍按实际变动规则计算，不再按问题类型覆盖默认手续费选项。
      this.disposeList[index].list[indexs].service_deal_suggest = this.shouldRefundDifference(items) ? '2' : '1'
      this.$forceUpdate()
    },
    // 替换链接
    replaceLink(items) {
      this.$refs.replaceLinkEdit.form = {
        problem_goods_id: items.problem_goods_id,
        link: '',
        from_platform: '',
        goods_id: '',
        pic: '',
        shop_id: '',
        shop_name: '',
        detail: [],
        sku_id: '',
        spec_id: '',
        detail_y: [],
        sku_id_y: '',
        spec_id_y: '',
      }
      this.$refs.replaceLinkEdit.dialogVisible = true
    },
    // 刷新数据
    refresh(data) {
      let replace_goods_info = {}
      this.disposeList.forEach(item => {
        item.list.forEach(items => {
          if (items.problem_goods_id == data.problem_goods_id) {
            replace_goods_info = {
              new: data,
              original: {
                from_platform: items.from_platform,
                goods_id: items.goods_id,
                shop_id: items.shop_id,
                shop_name: items.shop_name,
                pic: items.pic,
                detail: items.detail,
                sku_id: items.sku_id,
                spec_id: items.spec_id,
                detail_y: items.detail_y,
                sku_id_y: items.sku_id_y,
                spec_id_y: items.spec_id_y,
                link: items.link,
              }
            }
            items.replace_goods_info = replace_goods_info
          }
        })
      })
      this.$emit('refresh', replace_goods_info)
      this.$forceUpdate()
    }
  },
};
</script>
<style lang='scss' scoped>
@import "@/css/mixin.scss";

.table {
  padding: 0 10px;
  max-height: 600px;
  overflow-y: auto;
  position: relative;

  ol {
    display: flex;
    font-size: 14px;
    height: 40px;
    background-color: #edeff4;
    color: #909399;
    font-weight: 600;
    position: sticky;
    left: 0;
    top: 0;
    z-index: 999;
  }

  ul {
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    padding: 10px 0;
    font-size: 12px;
    transition: 0.25s;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }

    li {
      width: 100%;
      overflow: hidden;

      //   max-height: 80px;
      label {
        width: 100%;
        height: 100%;
      }

      .template {
        text-align: left;
        width: 100%;
        max-height: 100px;

        p {
          line-height: 20px;
          width: 100%;
          text-align: left;
        }
      }

      .scope {
        max-height: 100px;

        p {
          line-height: 20px;
        }
      }

      .imgList {
        display: flex;
        flex-wrap: wrap;
        text-align: center;

        .imgs {
          margin: 0 20px 10px 0;

          &:nth-child(even) {
            margin-right: 0;
          }

          &:nth-child(n + 2) {
            margin-bottom: 0;
          }

          img {
            width: 50px;
            height: 50px;
          }
        }
      }
    }

    .img {
      img {
        width: 60px;
        height: 60px;
        border-radius: 4px;
      }
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 3px;
  }

  .flex05 {
    flex: 0.5;

  }

  .flex15 {
    flex: 1.3;
  }

  .flex2 {
    flex: 1.7;
  }

  .flex25 {
    flex: 2.3;
  }

  .detail {
    .head {
      height: 50px;
      display: flex;
      background-color: #dedeef;
      font-size: 14px;
      line-height: 50px;
      padding: 0 20px;

      a {
        color: #036eb8;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .noData {
    padding: 20px 0;
    text-align: center;
  }
}

/deep/.el-textarea__inner {
  height: 80px;
  padding: 3px;
}

/deep/.el-input__inner {
  padding: 2px;
  text-align: center;
}

.footer {
  overflow: hidden;

  .radio {
    margin-right: 24px;

    p {
      line-height: 20px;
      width: 400px;
      text-align: left;
    }

    span {
      display: inline-block;

      &:nth-child(1) {
        margin-right: 20px;
      }
    }
  }
}

.difference {
  color: #B4272D
}
</style>
